import {
  MAX_ATTRIBUTION_VALUE_LENGTH,
  type MarketingAttribution,
} from "../../shared/mutators/completeProfile";
import { readSignupAttribution } from "./signupAttribution";

// The HQ lead story reads these to attribute a demo request to the in-product
// banner rather than to however the user first found us, so they're stamped on
// at request time — the same values the Tines app sends to the same webhook.
const PRODUCT_UTM = {
  utm_source: "product",
  utm_medium: "banner",
  utm_campaign: "demo-request",
};

export function demoRequestAttribution(): MarketingAttribution {
  const url = new URL(window.location.href);
  for (const [key, value] of Object.entries(PRODUCT_UTM)) {
    url.searchParams.set(key, value);
  }
  return {
    lastUtmUrl: url.toString().slice(0, MAX_ATTRIBUTION_VALUE_LENGTH),
    lastReferrer: externalReferrer().slice(0, MAX_ATTRIBUTION_VALUE_LENGTH),
    firstLandingPage: readSignupAttribution()?.firstLandingPage ?? "",
  };
}

// An in-app navigation or a hop from the marketing site says nothing about
// where the lead came from, so only a genuinely foreign referrer is reported.
function externalReferrer(): string {
  const { referrer } = document;
  if (!referrer) return "";
  let hostname: string;
  try {
    const parsed = new URL(referrer);
    if (parsed.origin === window.location.origin) return "";
    hostname = parsed.hostname;
  } catch {
    return "";
  }
  return hostname === "tines.com" || hostname.endsWith(".tines.com")
    ? ""
    : referrer;
}
